<template>
    <div class="management-index">
      <!-- 根据路由 meta 信息判断是否显示导航栏 -->
      <NavBar v-if="$route.meta.showNav" />
      <router-view />
    </div>
  </template>
  
  <script>
  import NavBar from "../../components/MyNavBar.vue";
  
  export default {
    name: "ManagementIndex",
    components: {
      NavBar,
    },
  };
  </script>
  
  <style scoped>
  </style>